export default __webpack_public_path__ + "static/media/loginBackground.246b6311.png";